// Mock data and functions for frontend-only functionality

// Store subscriptions in local storage
export const mockSubscribe = (email) => {
  const subscribers = JSON.parse(localStorage.getItem('subscribers') || '[]');
  
  if (!subscribers.includes(email)) {
    subscribers.push({
      email,
      subscribedAt: new Date().toISOString()
    });
    localStorage.setItem('subscribers', JSON.stringify(subscribers));
  }
  
  return {
    success: true,
    message: 'Successfully subscribed!'
  };
};

// Get all subscribers (for testing purposes)
export const getSubscribers = () => {
  return JSON.parse(localStorage.getItem('subscribers') || '[]');
};

// Store waitlist signups in local storage
export const mockWaitlistSignup = (data) => {
  const waitlist = JSON.parse(localStorage.getItem('waitlist') || '[]');
  
  const existing = waitlist.find(item => item.email === data.email);
  if (!existing) {
    waitlist.push({
      ...data,
      signedUpAt: new Date().toISOString()
    });
    localStorage.setItem('waitlist', JSON.stringify(waitlist));
  }
  
  return {
    success: true,
    message: 'Successfully joined waitlist!'
  };
};

// Get all waitlist signups (for testing purposes)
export const getWaitlist = () => {
  return JSON.parse(localStorage.getItem('waitlist') || '[]');
};
